import React, { PureComponent } from "react";
import styled from 'styled-components';
import { Loader } from "react-loaders";
import DateTimePicker from 'react-datetime';

const Table = styled.table`
  width: 100%;
  border-top: 1px solid #D5D9DD;
  margin-top: 20px;
  font-family: 'Mukta Vaani';
  border-collapse: separate;
  border-spacing: 0 20px;
`;

const RoundNameCell = styled.td`
  vertical-align: top;
  width: 100px;
`;

const RoundName = styled.span`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.38);
`;

const RoundDateTimeCell = styled.td`
  padding: 0 20px;
`;

const RoundDateTimeLabel = styled.span`
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
  margin-bottom: 6.5px;
  display: inline-block;
`;

const RoundUpdateButtonCell = styled.td`
  vertical-align: bottom;
`;

const RoundUpdateButton = styled.button`
  background: #F5F6F7;
  border-radius: 4px;
  padding: 6.5px 9.5px;
  color: rgba(0, 27, 59, 0.38);
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  pointer-events: none;
  margin-bottom: 3px;
  min-width: 78px;

  ${p => p.isActive && `
    background: #2196F3;
    color: #fff;
    pointer-events: auto;
  `}
  ${p => p.isActiveDefault && `
    background: #FF5252;
  `}
`;

const ButtonLoader = styled.div`
  width: 100%;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;

  > .loader {
    margin-top: 0 !important;
    margin-left: 0 !important;

    .loader-inner div {
      width: 15px;
      height: 15px;
      border-color: #fff !important;
    }
  }
`;

class TeamsRolesTable extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      defaultRounds: [1, 2, 3]
    };
  }

  render() {
    const {
      rounds,
      onChange,
      changedRounds,
      onUpdate,
      loadingButtonRound,
      defaultActiveRounds
    } = this.props;

    const { defaultRounds } = this.state;
    return (
      <Table>
        <tbody>
          {
            rounds.map((round, index) => {
              const isActiveDefault = defaultActiveRounds.includes(round.id);
              const isChanged = changedRounds.includes(round.id);

              const isUpdateButtonActive = isActiveDefault ? true : isChanged;
              const isUpdateButtonLoading = loadingButtonRound === round.id;
              const updateButtonText = isActiveDefault
                ? 'Activate'
                : isChanged
                  ? 'Update'
                  : 'Updated';
              const rowClass = isActiveDefault || isChanged ? 'with-highlighted-time' : '';

              return (
                <tr key={index} className={rowClass}>
                  <RoundNameCell><RoundName>Round {round.number}</RoundName></RoundNameCell>
                  <RoundDateTimeCell>
                    <RoundDateTimeLabel>Start</RoundDateTimeLabel>
                    <DateTimePicker
                      dateFormat="ddd, MMM DD YYYY,"
                      timeFormat="hh:mm a"
                      inputProps={{
                        placeholder: "Select Date & Time",
                        className: "instructor-round-datetime-selector"
                      }}
                      value={round.start_date}
                      onChange={
                        dt => {
                          onChange(dt, round.id, "start_date");
                        }
                      }
                    />
                  </RoundDateTimeCell>
                  <RoundDateTimeCell>
                    <RoundDateTimeLabel>End</RoundDateTimeLabel>
                    <DateTimePicker
                      dateFormat="ddd, MMM DD YYYY,"
                      timeFormat="hh:mm a"
                      inputProps={{
                        placeholder: "Select Date & Time",
                        className: "instructor-round-datetime-selector"
                      }}
                      value={round.end_date}
                      onChange={dt => onChange(dt, round.id, "end_date")}
                    />
                  </RoundDateTimeCell>
                  <RoundUpdateButtonCell>
                    <RoundUpdateButton
                      isActive={isUpdateButtonActive}
                      isActiveDefault={isActiveDefault}
                      onClick={() => {
                        let testArray = [...defaultRounds];
                        testArray.splice(round.id - 1, 1);
                        this.setState({
                          defaultRounds: testArray
                        })
                        onUpdate(round.id)
                      }}
                    >
                      {
                        isUpdateButtonLoading &&
                        <ButtonLoader>
                          <Loader type="ball-scale-ripple" active />
                        </ButtonLoader>
                      }
                      {
                        !isUpdateButtonLoading &&
                        <span>{updateButtonText}</span>
                      }
                    </RoundUpdateButton>
                  </RoundUpdateButtonCell>
                </tr>
              );
            })
          }
        </tbody>
      </Table>
    );
  }
}

export default TeamsRolesTable;



// WEBPACK FOOTER //
// ./src/instructor/components/round-admin/table.js